import { useAppDispatch } from '../../../../store';

export const useAdminConversationCategoriesList = () => {
    const dispatch = useAppDispatch();
    return {};
};
